
const moment = require("moment-timezone");

/**
 * Render a UTC-serialized timestamp (created_at / updated_at) in King County time.
 *
 * The zone is America/Los_Angeles — it was America/Denver, which is Mountain time and
 * therefore an hour ahead of King County, so every "Creation Date" column using these
 * helpers read an hour late.
 *
 * (The names are historical — these convert FROM UTC, they don't convert TO it.)
 */
export const convertTimeToUTCFormatted = (dateTimeString) => {
  return  moment.utc(dateTimeString, "YYYY-MM-DD HH:mm").tz("America/Los_Angeles").format("YYYY-MM-DD HH:mm")
}
export const convertTimeToUTC = (dateTimeString) => {
  return  moment.utc(dateTimeString, "DD-MM-YYYY HH:mm").tz("America/Los_Angeles").format("YYYY-MM-DD HH:mm")
}
